import React from 'react';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../CommonComponents/OPL/Text/Text';
import { Tooltip } from '../../../CommonComponents/OPL/Tooltip/Tooltip';
import { Icon } from '../../../CommonComponents/OPL/Icon/Icon';

interface Props {
  title: string;
  description?: string;
  tooltip?: string;
  children?: React.ReactNode;
}

export const ProfilePageHeader = ({ title, description, tooltip, children }: Props) => {
  return (
    <Box
      as="header"
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      gridGap="40"
      mb="32"
    >
      <Box>
        <Text as="h1" fontSize="h5" fontWeight={600} color="neutral.600" m="0">
          {title}
        </Text>

        {!!description && (
          <Box display="flex" alignItems="baseline">
            <Text as="p" color="neutral.500" mt="4">
              {description}

              {tooltip && (
                <Tooltip content={tooltip}>
                  <Icon
                    className="far fa-info-circle"
                    color="neutral.500"
                    fontSize="small"
                    ml="4"
                  />
                </Tooltip>
              )}
            </Text>
          </Box>
        )}
      </Box>

      {!!children && <Box flexShrink={0}>{children}</Box>}
    </Box>
  );
};
